/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { configureStore } from "@reduxjs/toolkit";

import { createNewsLoginSubscriber } from "~/features/news/subscribers";
import { createPromoToolsLoginSubscriber } from "~/features/promoTools/subscribers";
import { createUserGuideLoginSubscriber } from "~/features/userGuide/subscribers";
import rootReducer from "~/state/rootReducer";

export const createStore = () => {
  const store = configureStore({
    reducer: rootReducer,
  });

  store.subscribe(createUserGuideLoginSubscriber(store));
  store.subscribe(createPromoToolsLoginSubscriber(store));
  store.subscribe(createNewsLoginSubscriber(store));

  return store;
};
